import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PartnerDetailsComponent } from './partner-details/partner-details.component';
import { OurPartnersComponent } from './our-partners/our-partners.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PartnerLinkComponent } from './partner-link/partner-link.component';
import { ListService } from '../services/list.service';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { BeachwatchPartnersService } from '../services/beachwatch-partners.service';
import { SitesService } from '../services/sites.service';


@NgModule({
	declarations: [OurPartnersComponent, PartnerDetailsComponent, PartnerLinkComponent],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		SharedCompsModule		
	],
	exports : [],
	providers : [SitesService, ListService, BeachwatchPartnersService]
})
export class BeachwatchPartnersModule { }
